import { css } from "styled-components";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  .simple {
    border: 1px solid ${paletteTokens.keyline};
  }

  .ornamental {
    height: 4px;
    border: none;
    border-top: 2px solid ${paletteTokens.keyline};
    border-bottom: 1px solid ${paletteTokens.keyline};
  }
`;
//# sourceMappingURL=index.js.map